module.exports = __webpack_public_path__ + "static/media/Balenciaga-White-Race-Runner-Sneakers-Lyst_thumb.f8cd39ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/sneakers/Balenciaga-White-Race-Runner-Sneakers-Lyst_thumb.png
// module id = 296
// module chunks = 0